import { render, staticRenderFns } from "./BlogRecent.vue?vue&type=template&id=2bb9caf0&scoped=true&"
import script from "./BlogRecent.vue?vue&type=script&lang=js&"
export * from "./BlogRecent.vue?vue&type=script&lang=js&"
import style0 from "./BlogRecent.vue?vue&type=style&index=0&id=2bb9caf0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9caf0",
  null
  
)

export default component.exports